export default {
    "lang": "Монгол",
    application: {
        name: "Мэдээллийн мэдээллийн систем",
    },
    ajaxTip: {
        success: 'Амжилттай',
        error: 'Амжилтгүй',
        noAccess: 'Энэ нөөц рүү хандах эрхгүй',
        notFound: 'Хандах нөөц байхгүй',
        serverBusy: 'Сервер нь завсарлаж байна',
        timeOut: 'Хугацаа хэтэрсэн',
    },
    menu: {
        home: 'Нүүр',
        template: 'Загвар удирдах',
        program: 'Програм удирдах',
        playplan: 'Тоглуулах төлөвлөгөө',
        device: 'Төхөөрөмж удирдах',
        "source-material": 'Суурь материал удирдах',
        material: 'Суурь материал',
        checkManage: 'Шалгалт удирдах',
        setting: 'Тохиргоо',
        usercenter: "Хэрэглэгчийн төв",
        adminManage: "Төхөөрөмж удирдах",
        schedule: "Төгсөөгүй ажил",
        capitalassets: "Хөрөнгийн удирдлага",
        modifyPassword: "Нууц үг өөрчлөх",
        logout: "Нэвтрэхээс гарах",
        add: "Нэмэх",
        edit: "Засварлах",
        delete: "Устгах",
        view: "Харах",
        "menu_1": "Нүүр",
        "menu_2": "Төхөөрөмж удирдах",
        "menu_3": "Засварлах (Нарийн тохируулга - Энгийн засвар - Сүлжээ солих)",
        "menu_4": "Шуурхай команд",
        "menu_5": "Засварлах (Байгууллага шилжүүлэх)",
        "menu_6": "Стратеги",
        "menu_7": "Дууны тохируулга",
        "menu_8": "Гэрэлтэлтийн тохируулга",
        "menu_9": "Утгаж авах тохируулга",
        "menu_10": "Унтлагийн тохируулга",
        "menu_11": "Төхөөрөмжийн шинж чанар",
        "menu_12": "Засварлах/Нэмэх",
        "menu_13": "Програм удирдах",
        "menu_14": "Нийтлэлийн түүх",
        "menu_15": "Устгах (Бүлэг/Нэг)",
        "menu_16": "Нийтлэгдэж буй программ",
        "menu_17": "Ангилал",
        "menu_19": "Програм жагсаалт",
        "menu_20": "Агуулга засварлах",
        "menu_21": "Програм хуулбарлах",
        "menu_23": "Програм нийтлэх",
        "menu_24": "Суурь материал удирдах",
        "menu_25": "Хуулбараалах",
        "menu_28": "Хурдан нийтлэх",
        "menu_29": "Загвар удирдах",
        "menu_30": "Нийтлэг загвар",
        "menu_31": "Шууд ашиглах",
        "menu_32": "Миний загварууд",
        "menu_33": "Нийтлэг загварт нийтлэх",
        "menu_35": "Хуваалцах түүх",
        "menu_36": "Шалгалт удирдах",
        "menu_37": "Програм шалгах",
        "menu_38": "Шалгах (Зөвшөөрөх/Татгалзах)",
        "menu_39": "Суурь материал шалгах",
        "menu_41": "Шалгалтын түүх (Ажилтан)",
        "menu_42": "Шалгалтын түүх (Шалгагч)",
        "menu_43": "Шалгалтын тоо харах",
        "menu_44": "Байгууллагын удирдлага",
        "menu_45": "Лоог удирдлага",
        "menu_46": "Тоглуулах лоог",
        "menu_47": "Нийтлэлийн лоог",
        "menu_48": "Алдааны лоог",
        "menu_49": "Үйлдлийн лоог",
        "menu_50": "Файлын лоог",
        "menu_51": "Нэвтрэх лоог",
        "menu_52": "Агуулга шалгах",
        "menu_53": "Хадгалах зай",
        "menu_54": "Байгууллагын бүтэц",
        "menu_55": "Үүрэг эрх",
        "menu_56": "Зөвшөөрөл",
        "menu_57": "Харах (Зөвшөөрлийн эрх)",
        "menu_58": "Байгууллагын гишүүд",
        "menu_60": "Доорх түвшний хэрэглэгчийн нууц үг дахин тохируулах",
        "menu_61": "Хөрөнгийн удирдлага",
        "menu_62": "Миний тэнхлэг",
        "menu_63": "Харах (Мөнгөний нарийвчлал)",
        "menu_64": "Миний урсгал",
        "menu_65": "Харах (Урсгал нарийвчлал)",
        "menu_66": "Урсгал худалдан авах",
        "menu_67": "Миний багтаамж",
        "menu_68": "Миний төхөөрөмж",
        "menu_69": "Захиалгын нарийвчлал",
        "menu_70": "Харах (Цэнэглэлт)",
        "menu_71": "Харах (Загвар худалдан авах)",
        "menu_72": "Харах (Урсгал худалдан авах)",
        "menu_73": "Бусад эрх",
        "menu_74": "Харах (Суурь материал программ статистикийг)",
        "menu_75": "Харах (Хөрөнгө)",
        "menu_76": "Харах (Оюуны урсгал/статистик)",
        "menu_77": "Харах (Төхөөрөмжийн онлайн статистикийг)"
    },
    login: {
        terminalServiceSystem: 'Оюуны төгсгөлийн үйлчилгээний систем',
        accountLogin: 'Бүртгэлээр нэвтрэх',
        register: 'Бүртгүүлэх',
        accountLoginTip: 'Бүртгэлтэй бол нэвтрэнэ үү',
        scanQRCode: 'QR кодыг скан хийнэ үү',
        readAndAgree: 'Би уншиж зөвшөөрлөө',
        readAndAgreeLink: 'Хэрэглэгчийн үйлчилгээний гэрээ',
        readAndAgreeAgreement: 'Хэрэглэгчийн үйлчилгээний гэрээг уншиж зөвшөөрнө үү',
        forgetpassword: "Нууц үгээ мартах уу?",
        resetpassword: "Нууц үг сэргээх",
        phoneEmptyTip: "Утасны дугаар оруулна уу",
        nextStep: "Дараагийн алхам",
        title: 'Сайн байна уу?',
        submit: 'Нэвтрэх',
        userName: 'Бүртгэл',
        password: 'Нууц үг',
        userNameEmptyTip: 'Бүртгэл оруулна уу',
        passwordEmptyTip: 'Нууц үг оруулна уу',
        passwordFormatTip: 'Зөв нууц үгийн хэлбэр оруулна уу',
        passwordIsOk: 'Баталгаажуулах нууц үг оруулна уу',
        passwordSign: 'Нууц үг оруулна уу',
        codeTip: "Дугаар оруулна уу",
        phone: "Утасны дугаар хоосон байж болохгүй",
        code: "Дугаар хоосон байж болохгүй",
        nickname: "Компанийн нэр хоосон байж болохгүй",
        pass: "Нууц үг хоосон байж болохгүй",
        pwdMessage: "Нууц үг 8~20 тэмдэгт урттай, зай агуулаагүй, том, жижиг үсэг, тоо, онцгой тэмдэгтнүүдээс 3 төрлийг агуулсан байх ёстой",
        pwdMessage01: "Нууц үгийг үсэг + тоогоор 8 цифрээс дээш оруулна уу",
        pwdMessage02: "Нууц үгийн урт 8-20 тэмдэгт",
        pwdMessage03: "Нууц үг зай агуулахгүй байх ёстой",
        pwdMessage04: "Нууц үг том үсэг, жижиг үсэг, тоо, тэмдэгтээс 3 төрлийг агуулсан байх ёстой",
        newpassempty: "Шинэ нууц үг хоосон байж болохгүй",
        newpass: "Хоёр нууц үг ижил биш байна",
        getcode: "Дугаар авах",
        format: "Утасны дугаарын хэлбэр буруу байна",
        chongfa: "секундийн дараа дахин илгээх",
        isSend: 'Илгээсэн',
        noregister: "Бүртгэлгүй юу? Шууд бүртгүүлэх",
        Mobile: "Утасны дугаар",
        verificationcode: "Дугаар",
        petname: "Нэр",
        Quickregistration: "Хурдан бүртгүүлэх",
        xiugaimima: "Нууц үг өөрчлөх",
        jiumima: "Хуучин нууц үг",
        xinmima: "Шинэ нууц үг",
        zaicishuruxinmima: "Шинэ нууц үгийг дахин оруулна уу",
        xiugaichenggong: "Өөрчилсөн амжилттай",
        xiugaishoujihao: "Утасны дугаар өөрчлөх",
        dengluzhanghao: "Нэвтрэх бүртгэл",
        gongsiid: "Компаний ID",
        yonghunicheng: "Хэрэглэгчийн нэр",
        chuangjianshijian: "Үүсгэсэн цаг",
        gongsimingcheng: "Компанийн нэр",
        denglumima: "Нэвтрэх нууц үг",
        jianyi: "Үсэг тоо хослосон нууц үг ашиглахыг зөвлөж байна",
        shezhimima: "Нууц үг тохируулах",
        shezhishoujihao: "Утасны дугаар өөрчлөх/тохируулах",
        yibangding: "Холбогдсон",
        weibangding: "Холбоогүй",
        zhanghuanquan: "Бүртгэлийн аюулгүй байдал",
        yonghuxinxi: "Хэрэглэгчийн мэдээлэл",
        zhuceSucMsg: 'Баяр хүргэе, амжилттай бүртгэгдлээ!',
        verificationcodeSucMsg: "Дугаар амжилттай илгээгдлээ!",
        requiredIsEmpty: "Шаардлагатай талбарууд хоосон байж болохгүй!",
        emailObj: {
            title: 'Имэйл',
            tit: 'Имэйлээр нэвтрэх',
            tip: 'Имэйл хаяг оруулна уу',
            formatTip: 'Зөв имэйл хэлбэр оруулна уу',
        },
        phoneObj: {
            title: 'Утасны дугаар',
            tit: 'Утасны дугаараар нэвтрэх',
            tip: 'Утасны дугаар оруулна уу',
            formatTip: 'Зөв утасны дугаарын хэлбэр оруулна уу',
        },
        emailOrPhoneObj: {
            title: 'Имэйл эсвэл утасны дугаар',
            tit: 'Имэйл эсвэл утасны дугаараар нэвтрэх',
            tip: 'Имэйл эсвэл утасны дугаар оруулна уу',
            formatTip: 'Зөв имэйл эсвэл утасны дугаарын хэлбэр оруулна уу',
        },
        wechatObj: {
            title: 'Вэйт',
            tit: 'Вэйтээр нэвтрэх',
        },
        googleObj: {
            title: 'Гурил',
            tit: 'Гурилээр нэвтрэх',
        },
        confirm: 'Баталгаажуулах',
        confirmSubmit: 'Илгээхэд баталгаажуулах',
        cancel: 'Цуцлах',
        close: 'Хаах',
        bindSucMsg: 'Холбогдсон амжилттай',
        toContinueBindAccount: 'Гуравдагч бүртгэлийг холбох үйлдлийг үргэлжлүүлэх',
        bindTip01: 'Бүртгэлгүй юу? Бүртгүүлэх',
        bindTip02: 'Бүртгэлтэй бол',
        bindTip03: 'Одоогийн гуравдагч бүртгэл платформийн бүртгэлтэй холбоогүй байна, өмнөх бүртгэлтэй холбох эсвэл шинэ бүртгэлээр бүртгүүлэх шаардлагатай. Дараагийн удаад хурдан нэвтрэх боломжтой.',
        bindTip04: 'Өмнөх бүртгэлтэй холбох',
        bindTip05: 'Бүртгэж шинэ бүртгэлтэй холбох',
        bindTip06: 'Та гуравдагч зөвшөөрлөөр нэвтрээд, дараах нэвтрэх мэдээллийг бүрэн болгохад холбогдолт амжилттай болно',
        bindSubmit: 'Холбогдолт илгээх',
        enterAccountTip: 'Бүртгэлийн нэр оруулна уу',
        RegisterAndBind: 'Бүртгэж холбох',
        loginErr: 'Хэрэглэгчийн нэр эсвэл нууц үг буруу байна!',
        usercenter: "Хэрэглэгчийн төв",
        pleaseInputName: "Нэр оруулна уу",
        operationSuccess: "Үйлдэл амжилттай!",
        edit: "Засварлах",
        xiugai: "Өөрчлөх",
        userData: "Хувийн мэдээлэл",
        changePassword: "Нууц үг өөрчлөх",
        account: "Бүртгэл",
        userName01: "Хэрэглэгчийн нэр",
        phoneNumber: "Утасны дугаар",
        role: "Үүрэг",
        createTime: "Үүсгэсэн цаг",
        genghuang: "Солих",
        bangding: "Холбох",
        unbind: "Холбогдохгүй болгох",
        plesaseSelectBindingType: "Холбох төрлийг сонгоно уу",
        pleaseConfirmCont: "Би үүнийг уншсантай ижил байна гэдгээ баталгаажуулна уу",
        confirmReadCont: "Би үүнийг уншсан",
        frequentTip: "Хэт олон удаа үйлдлээ, арай удахад дахин оролдоно уу!",
        zhuxiaoBtn: "Бүртгэлийг устгах",
        zhuxiaoTitle: "Бүртгэлийг устгах",
        querenZhuxiao: "Устгахад баталгаажуулах",
        jiXu: "Үргэлжлүүлэх",
        sendCodeBtn: "Дугаар илгээх",
        passwordIsNotOldPassword: "Баталгаажуулах нууц үг шинэ нууц үгтэй зөрчилтэй байна",
        passwordIsOldPassword: "Өөрчилсөн нууц үг хуучин нууц үгтэй ижил байна",
        passFormatError: "Зөв нууц үгийн хэлбэр оруулна уу",
        oldPassWord: "Хуучин нууц үг",
        newPassWord: "Шинэ нууц үг",
        inputPlaceholder: 'Оруулна уу',
        confirmPassword: "Баталгаажуулах нууц үг",
        zhuxiaoTip: `
            1、Бүртгэлийг устгах нь сэргээх боломжгүй үйлдэл юм. Бүртгэл устсаны дараа та энэ бүртгэлээр нэвтрэх, энэ бүртгэлээр бүртгүүлсэн гуравдагч бүртгэлээр нэвтрэх боломжгүй болно. Бүртгэлийн холбоо барих мэдээлэл болон өгөгдлийг өөрийн ачаар хадгалаарай.
            2、Бүртгэл устгахын өмнө таны бүх хөрөнгө ашиг хонгилыг цэвэрлэсэн эсэхийг, мөн ямар ч маргаан байхгүй эсэхийг баталгаажуулна уу. Бүртгэл устгасны дараа та бүх хөрөнгө ашиг хонгилын эзэмшлийг орхисон гэж үзнэ бөгөөд сэргээх эсвэл олж авах боломжгүй болно.
            3、Ижил утасны дугаараар бүртгүүлсэн бүртгэл 3 удаа устгасан бол тухайн утасны дугаараар шинэ бүртгэл үүсгэх, мөн бусад бүртгэлтэй холбох боломжгүй болно.
            `
    },
    home: {
        title: "Нүүр",
        quickOperation: "Хурдан үйлдэл",
        addDevice: "Төхөөрөмж нэмэх",
        publishProgram: "Програм нийтлэх",
        publishMaterial: "Суурь материал нийтлэх",
        makeProgram: "Програм үйлдвэрлэх",
        uploadMaterial: "Суурь материал хуулбараалах",
        todayData: "Өнөөдрийн өгөгдөл (цаг тутам шинэчлэгдэнэ)",
        playNumChart: "Тоглуулах тооны статистикийн диаграм",
        deviceOnlineStatus: "Төхөөрөмжийн онлайн төлөв",
        onLineDevice: "Онлайн төхөөрөмж",
        unLineDevice: "Офлайн төхөөрөмж",
        programPlayTime: "Програм тоглуулах хугацааны статистикийн диаграм",
        downloadSoft: "Програм утгаж авах",
        adminApp: "Утасны хэрэглэгчийн програмыг",
        playerApp: "Мэдээллийн мэдээллийн төгсгөлийн програм",
        downloadAdminApp: "Хэрэглэгчийн програмыг утгаж авах",
        downloadPlayerApp: "Тоглуулах програмыг утгаж авах",
        aboutUs: "Манай тухай",
        userManual: "Хэрэглэгчийн гарын авлага",
        message: "Мессеж бичих",
    },
    device: {
        inputPlaceholder: 'Оруулна уу',
        selectPlaceholder: 'Сонгоно уу',
        osTypeStr: 'Төгсгөлийн систем',
        onLineStatus: 'Онлайн төлөв',
        dpi: 'Зураглал',
        companyDeptIdName: 'Харьяалагдах байгууллага',
        deviceGroupIdName: 'Харьяалагдах ангилал',
        editOrMove: 'Засварлах/Шилжүүлэх',
        loanOriginationFee: 'Зээлийн гүйлгээний хураамж',
        strategyInfoLook: 'Стратегийн мэдээллийг харах',
        programLook: 'Програм харах',
        addEquipments: 'Төхөөрөмж нэмэх',
        luminanceSet: 'Гэрэлтэлтийн тохируулга',
        terminal: 'Төгсгөлийн тохируулга',
        transferCompany: 'Байгууллага шилжүүлэх',
        releasedProgram: 'Програм нийтлэх',
        screenshot: 'Дэлгэц авах',
        changeGroup: 'Ангилал солих',
        defaultGroup: "Анхдагч ангилал",
        operation: "Үйлдэл",
        edit: "Засварлах",
        saveEdit: "Засварыг хадгалах",
        add: "Нэмэх",
        save: "Хадгалах",
        setting: "Тохиргоо",
        program: "Програм",
        unbind: "Холбогдохгүй болгох",
        sleep: "Унтах",
        wakeup: "Сэргээх",
        restart: "Дахин ачаалах",
        shutdown: "Унтраах",
        reportLog: "Лоог илгээх",
        clearPlayData: "Тоглуулах өгөгдлийг цэвэрлэх",
        offlineWarn: "Энэ төхөөрөмж офлайн байна, төхөөрөмж онлайн болоход дахин оролдоно уу!",
        confirmUnbind: "Холбогдохгүй болгоход баталгаажуулах",
        confirmReset: "Цэвэрлэхэд баталгаажуулах",
        confirmDelete: "Устгахад баталгаажуулах",
        delete: "Устгах",
        cancelDelete: "Устгалыг цуцлах",
        confirmResetSuccess: "Цэвэрлэсэн амжилттай",
        confirm: "Баталгаажуулах",
        cancel: "Цуцлах",
        operationSuccess: "Үйлдэл амжилттай",
        unbindSuccess: "Холбогдохгүй болгосон амжилттай",
        pleaseSelectDevice: "Төхөөрөмж сонгоно уу",
        pleaseSelectOnlineDevice: "Онлайн төхөөрөмж сонгоно уу",
        confirmMixOperation: "Сонгосон төхөөрөмжид офлайн төхөөрөмж байгаа тул энэ тохируулга офлайн төхөөрөмжид үйлчлэхгүй. Үргэлжлүүлэх үү?",
        pleaseSelectDate: "Огноо сонгоно уу",
        reportSuccess: "Илгээсэн амжилттай",
        deviceSetting: "Төхөөрөмжийн тохируулга",
        default: "Анхдагч",
        all: "Бүгд",
        deviceList: "Төхөөрөмжийн жагсаалт",
        addDevice: "Төхөөрөмж нэмэх",
        department: "Байгууллага",
        deviceType: "Төрлийн зураглал",
        osType: "Төгсгөлийн систем",
        onlineState: "Онлайн төлөв",
        online: "Онлайн",
        offline: "Офлайн",
        notActive: "Идэвхгүй",
        search: "Түлхүүр үг оруулна уу",
        batchOperation: "Бүлэг үйлдэл",
        allDevices: "Бүх төхөөрөмж",
        deviceAttribute: "Төхөөрөмжийн шинж чанар",
        selectReportDate: "Илгээх огноо сонгох",
        inputName: "Нэр оруулна уу",
        inputWidth: "Өргөн оруулна уу",
        inputHeight: "Өндөр оруулна уу",
        inputResolutionRatio: "0-ээс их бүхэл тоо оруулна уу!",
        inputSort: "Дарааллыг оруулна уу",
        serialNum: "Дугаар",
        name: "Нэр",
        width: "Өргөн",
        height: "Өндөр",
        resolutionRatio: "Зураглал",
        inputResolutionRatioName: "Зураглалын нэр оруулна уу",
        sort: "Дараалал",
        personal: "Хувь хүн",
        system: "Систем",
        type: "Төрөл",
        systemDefaultSettingUneditable: "Системийн анхдагч тохируулга засварлах боломжгүй!",
        systemDefaultSettingUnDeletable: "Системийн анхдагч тохируулга устгах боломжгүй!",
        newz: "Нэмэх",
        total: "Нийт",
        totalNum: "бүртгэл",
        strategyName: "Стратегийн нэр",
        associatedTerminalNum: "Холбоотой төгсгөлийн тоо",
        createTime: "Үүсгэсэн цаг",
        pleaseSelectStrategy: "Стратеги сонгоно уу!",
        onlySelectOneData: "Зөвхөн нэг мэдээлэл сонгох боломжтой!",
        downloadStrategy: "Стратегийг утгаж авах",
        inputStrategyName: "Стратегийн нэр оруулна уу",
        luminanceControl: "Гэрэлтэлтийн хяналт",
        volumeStrategy: "Дууны стратеги",
        saveSuccess: "Хадгалсан амжилттай",
        screenAngle: "Дэлгэцийн эргүүлэлт(°)",
        startTime: "Эхлэх хугацаа",
        endTime: "Дуусах хугацаа",
        repeat: "Дахих",
        monday: "Даваа",
        tuesday: "Мягмар",
        wednesday: "Лхагва",
        thursday: "Пүрэв",
        friday: "Баасан",
        saturday: "Бямба",
        sunday: "Ням",
        everyday: "Өдөр бүр",
        downloadSpeed: "Утгаж авах хурд",
        inputDownloadSpeed: "Утгаж авах хурдыг оруулна уу",
        operator: "Үйлдэл",
        pleaseSelectDeleteData: "Устгах мэдээллийг сонгоно уу!",
        confirmBatchDelete: "Бүлэг устгахад баталгаажуулах уу?",
        pleaseInputName: "Нэр оруулна уу",
        detailSetting: "Нарийвчилсан тохируулга",
        weekPlan: "Долоо хоногийн төлөвлөгөө",
        specialDateSetting: "Онцгой огнооны тохируулга",
        weekdayInfo: "Долоо хоногийн өдөр заавал сонгоно!",
        volumeInfo: "Дууны түвшин заавал сонгоно!",
        timeError: "Хугацааны сонголт буруу байна!",
        editSuccess: "Засварлах үйлдэл амжилттай!",
        addSuccess: "Нэмэх үйлдэл амжилттай!",
        addSpecialPlan: "Онцгой стратеги төлөвлөгөө нэмэх",
        downloadSpeedInfo: "Утгаж авах хурд:(0 нь утгаж авахыг хориглоно)",
        pleaseSelectStartTime: "Эхлэх хугацааг сонгоно уу",
        pleaseSelectEndTime: "Дуусах хугацааг сонгоно уу",
        luminanceError: "Зөв гэрэлтэлтийн утгыг оруулна уу!",
        defaultLuminance: "Анхдагч гэрэлтэлт",
        luminance: "Гэрэлтэлтийн хэмжээ",
        defaultLuminanceInfo: "Анхдагч гэрэлтэлт(100 нь хамгийн тодорхой, 0 нь хамгийн харанхуй)",
        volume: "Дуу",
        saveLuminance: "Гэрэлтэлтийг хадгалах",
        changeSuccess: "Өөрчилсөн амжилттай!",
        changeNetwork: "Сүлжээ солих",
        netName: "Сүлжээний нэр",
        nameempty: "Сүлжээний нэр хоосон байж болохгүй",
        currentNetwork: "Одоогийн сүлжээ",
        ipAddress: "IP хаяг",
        dailyMode: "Өдөр тутмын горим",
        weeklyMode: "Долоо хоногийн горим",
        turnOnTime: "Асаах хугацаа",
        turnOffTime: "Унтраах хугацаа",
        startSleep: "Унтлагыг эхлүүлэх",
        endSleep: "Унтлагыг дуусгах",
        batchDelInfo: "Сонгосон зүйлсийг устгахад баталгаажуулах уу?",
        timeCannotBeEmpty: "Хугацаа хоосон байж болохгүй!",
        startUp: "Асаах",
        shutDown: "Унтраах",
        volumeSize: "Дууны хэмжээ",
        defaultVolume: "Анхдагч дуу(100 нь хамгийн их, 0 нь дуугааргүй)",
        chooseStartTime: "Эхлэх хугацааг сонгоно уу",
        chooseEndTime: "Дуусах хугацааг сонгоно уу",
        saveVolume: "Дууны тохируулгыг хадгалах",
        screenRotationUnSaved: "Дэлгэцийн эргүүлэлт хадгалагдалгүй байна",
        volumeSettingUnSaved: "Дууны тохируулга хадгалагдалгүй байна",
        luminanceSettingUnSaved: "Гэрэлтэлтийн тохируулга хадгалагдалгүй байна",
        confirmClosePopup: "Энэ цонхыг хаахад баталгаажуулах уу?",
        volumeSettingSuccess: "Дууны тохируулга амжилттай өөрчлөгдлөө",
        luminanceSettingSuccess: "Гэрэлтэлтийн тохируулга амжилттай өөрчлөгдлөө",
        advancedSettingUnSaved: "Нарийн тохируулга хадгалагдалгүй байна",
        settingTitle: "Төгсгөлийн тохируулга",
        volumeSetting: "Дууны тохируулга",
        luminanceSetting: "Гэрэлтэлтийн тохируулга",
        downloadSetting: "Утгаж авах тохируулга",
        sleepSetting: "Унтлагийн тохируулга",
        onOffSetting: "Цаг асаах/унтраах",
        screenRotation: "Дэлгэцийн эргүүлэлт",
        namingError: "Нэршлийн алдаа, файлын нэрэнд зай байж болохгүй!",
        deleteSuccess: "Устгасан амжилттай",
        deleteFolder: "Хавтанг устгах",
        pleaseInputDeviceName: "Төхөөрөмжийн нэр оруулна уу",
        pleaseInputDeviceId: "Төхөөрөмжийн ID оруулна уу",
        discoverDevice: "Төхөөрөмж илрүүлэх",
        deviceId: "Төхөөрөмжийн ID",
        bound: "Холбогдсон",
        bind: "Холбох",
        noDevice: "Төхөөрөмж байхгүй",
        refresh: "Шинэчлэх",
        manualAdd: "Гараар нэмэх",
        deviceGroup: "Төхөөрөмжийн ангилал",
        pleaseSelectGroup: "Ангилал сонгоно уу!",
        deviceName: "Төхөөрөмжийн нэр",
        goAdd: "Нэмэх рүү очих",
        close: "Хаах",
        bindCountInsufficient: "Холбох тоо хүрэлцэхгүй байна, төхөөрөмжийн тоог нэмэгдүүлсний дараа нэмнэ үү!",
        displayNumber: "Харуулах дугаар",
        groupName: "Ангилалын нэр",
        pleaseSelectGroupName: "Ангилалын нэрийг бөглөнө үү!",
        moveGroup: "Ангилал шилжүүлэх",
        longitude: "Уртын градус",
        latitude: "Өргөргийн градус",
        nationality: "Иргэншил",
        province: "Аймаг",
        city: "Хот",
        county: "Сум",
        outNetIp: "Гадаад сүлжээний IP",
        inNetIp: "Дотоод сүлжээний IP",
        companyName: "Компанийн нэр",
        Info: "Дэлгэрэнгүй",
        android: "Андроид",
        win: "Win",
        osVersion: "Системийн хувилбар",
        softwareVersion: "Програм хангамжийн хувилбар",
        diskSize: "Дискийн хэмжээ",
        useSize: "Ашигласан хэмжээ",
        macAddr: "MAC хаяг",
        longitudeLatitudeInfo: "Уртын болон өргөргийн градус зэрэгцэн хоосон эсвэл хоосон биш байх ёстой!",
        terminalName: "Төгсгөлийн нэр",
        terminalGroup: "Төгсгөлийн ангилал",
        reportJournal: "Илгээх эсэх",
        systemVersion: "Системийн хувилбар",
        storageSpace: "Хадгалах зай",
        resolution: "Зураглал",
        runningMemory: "Ажиллах санах ой",
        model: "Загвар",
        registerStatus: "Бүртгэлийн төлөв",
        password: "Нууц үг",
        passwordInfo: "6-18 тэмдэгт үг эсвэл тоо оруулна уу!",
        group: "Ангилал",
        address: "Хаяг",
        remark: "Тэмдэглэл",
        renewalPeriod: "Дахин сунгах хугацаа",
        money: "Мөнгө",
        latitudeInfo: "Зөв өргөргийн градус оруулна уу!",
        totalPayment: "Нийт төлбөр",
        longitudeInfo: "Зөв уртын градус оруулна уу!",
        setMeal: "Багц",
        number: "Тоо",
        programName: "Программ нэр",
        playStatus: "Тоглуулах төлөв",
        playType: "Тоглуулах арга",
        play: "Тоглуулах",
        pause: "Түр зогсоох",
        playTime: "Тоглуулах хугацаа",
        programDeleted: "Программ устгагдсан",
        playSuccess: "Программ тоглуулахад зохион байгуулагдсан",
        pauseSuccess: "Түр зогсоосон амжилттай",
        playCycle: "Дугаарлах",
        playInsert: "Задлан тоглуулах",
        withdrawSuccess: "Татаж авсан амжилттай",
        withdrawInfo: "Татаж авах программ сонгоно уу!",
        programBelong: "Харьяалагдах программ",
        checkAll: "Бүгдийг сонгох",
        batchDel: "Бүлэг устгах",
        delConfirm: "Сонгосон зүйлсийг устгахад баталгаажуулах уу?",
        check: "Сонгосон",
        noProgram: "Программ байхгүй",
        details: "Дэлгэрэнгүй",
        screenshotFail: "Дэлгэц авах амжилтгүй боллоо",
        policyName: "Стратегийн нэр",
        terminalNum: "Холбоотой төгсгөлийн тоо",
        powerStrategy: "Цахилгаан стратеги",
        pleaseSelectDepartment: "Байгууллага сонгоно уу!",
        screenshotControl: "Дэлгэц авах хяналт",
        未激活: "Идэвхгүй",
        已激活: "Идэвхтэй",
        未绑定: "Холбоогүй",
        已绑定: "Холбогдсон",
    },
    programManage: {
        programList: "Программ жагсаалт",
        publishProgram: "Программ нийтлэлийн мөрдөх",
        week1: "Даваа",
        week2: "Мягмар",
        week3: "Лхагва",
        week4: "Пүрэв",
        week5: "Баасан",
        week6: "Бямба",
        week7: "Ням",
        monday: "Даваа",
        tuesday: "Мягмар",
        wednesday: "Лхагва",
        thursday: "Пүрэв",
        friday: "Баасан",
        saturday: "Бямба",
        sunday: "Ням",
        name: "Нэр",
        preview: "Урьдчилан харах",
        playDeviceNum: "Тоглуулах төхөөрөмжийн тоо",
        copyDeviceCode: "Хуулбарлахын тулд дарна уу",
        osType: "Системийн төрөл",
        playDate: "Тоглуулах огноо",
        playWeek: "Тоглуулах долоо хоног",
        everyday: "Өдөр бүр",
        start: "Эхлэх",
        end: "Дуусах",
        playOperateStatusStr: "Нийтлэлийн төлөв",
        playDevice: "Тоглуулах төхөөрөмж",
        downloadView: "Утгаж авах харах",
        publisher: "Нийтэлсэн хүн",
        publishTime: "Нийтлэсэн цаг",
        operation: "Үйлдэл",
        add: "Нэмэх",
        groupName: "Ангилалын нэр",
        selectDevice: "Төгсгөл сонгох",
        searchDevice: "Төгсгөл хайх",
        pleaseFillGroupName: "Ангилалын нэрийг бөглөнө үү!",
        remarkInfo: "Тэмдэглэл",
        compile: "Засварлах",
        withdrawConfirm: "Энэ программийг татаж авахад баталгаажуулах уу?",
        confirm: "Баталгаажуулах",
        cancel: "Цуцлах",
        withdraw: "Татах",
        batchWithdraw: "Бүлэг татах",
        batchPublish: "Бүлэг нийтлэх",
        batchDelete: "Бүлэг устгах",
        batchOperation: "Бүлэг үйлдэл",
        notUse: "Ашиглаагүй",
        notChecked: "Шалгаагаагүй",
        notPass: "Зөвшөөрөөгүй",
        delete: "Устгах",
        publishTextLeft: "Нийтлэсэн",
        offTextLeft: "Түр зогсоосон",
        pleaseSelectProgramToMove: "Шилжүүлэх программ сонгоно уу!",
        pause: "Түр зогсоох",
        pauseConfirm: "Түр зогсоох уу?",
        play: "Тоглуулах",
        downloadUdisk: "U-диск утгаж авах",
        deviceList: "Төхөөрөмжийн жагсаалт",
        groupSelection: "Ангилал сонгох",
        operationSuccess: "Үйлдэл амжилттай",
        deleteSuccess: "Устгасан амжилттай",
        selectDate: "Огноо сонгох",
        publishStatus: "Нийтлэлийн төлөв",
        checkStatus: "Шалгалтын төлөв",
        waitAuditing: "Шалгалт хүлээгдэж байна",
        auditPass: "Шалгалт зөвшөөрсөн",
        auditRefuse: "Шалгалт татгалзсан",
        all: "Бүгд",
        playStatus: "Тоглуулж байна",
        playStatust: "Тоглуулах төлөв",
        pauseStatus: "Түр зогсоосон",
        notStartStatus: "Эхлээгүй",
        resolutionratio: "Зураглал",
        totalNum: "бүртгэл",
        programName: "Программ нэр",
        playStartTime: "Тоглуулах эхлэх хугацаа",
        playEndTime: "Тоглуулах дуусах хугацаа",
        createTime: "Үүсгэсэн цаг",
        nationality: "Иргэншил",
        province: "Аймаг",
        city: "Хот",
        county: "Сум",
        address: "Хаяг",
        ip: "IP хаяг",
        location: "Байршил",
        log: "Лоог",
        pleaseFillProgramName: "Программ нэрийг бөглөнө үү!",
        selectGroup: "Ангилал сонгох",
        startTime: "Эхлэх хугацаа",
        endTime: "Дуусах хугацаа",
        publishCycle: "Нийтлэлийн мөчлөг",
        publishDeviceNum: "Нийтлэлийн төхөөрөмжийн тоо",
        pleaseSelectRecord: "Бүртгэл сонгоно уу",
        deviceName: "Төгсгөлийн нэр",
        deviceId: "Төгсгөлийн төхөөрөмжийн ID",
        deviceGroupIdName: "Байрлах ангилал",
        notClassified: "Ангилалгүй",
        osTypeStr: "Төгсгөлийн систем",
        storageSpace: "Хадгалах зай",
        onLineStatus: "Онлайн төлөв",
        onLine: "Онлайн",
        offLine: "Офлайн",
        sleep: "Унтах",
        unknown: "Үл мэдэгдэх",
        registerStatus: "Бүртгэлийн төлөв",
        trialPeriod: "Туршилтын хугацаа",
        notActive: "Идэвхгүй",
        active: "Идэвхтэй",
        parameterError: "Параметр буруу байна!",
        pleaseSelectProgram: "Программ сонгоно уу!",
        pleaseSelectProgramEdit: "Засварлах программ сонгоно уу!",
        confirmWithdrawSelectedProgram: "Сонгосон программийг татаж авахад баталгаажуулах уу?",
        withdrawSuccess: "Татаж авсан амжилттай",
        allPrograms: "Бүх программ",
        defaultGroup: "Анхдагч ангилал",
        cannotShareEmptyProgram: "Хоосон программийг хуваалцах боломжгүй!",
        onlyShareYourProgram: "Таны үүсгэсэн программийг л хуваалцах боломжтой!",
        pleaseSelectProgramEditPublishTime: "Нийтлэлийн хугацааг засварласны дараа сонгоно уу!",
        pleaseSelectDevice: "Төхөөрөмж сонгоно уу!",
        programDetail: "Программийн дэлгэрэнгүй",
        errorReason: "Алдааны шалтгаан",
        availableStorageSpaceInsufficient: "Хүртэмжтэй хадгалах зай хүрэлцэхгүй байна",
        partialDeviceReleaseFailure: "Зарим төхөөрөмж нийтлэх амжилтгүй боллоо",
        allDeviceReleaseSuccess: "Бүх төхөөрөмж нийтлэх амжилттай",
        partialDeviceReleaseSuccess: "Зарим төхөөрөмж нийтлэх амжилттай",
        allGroup: "Бүх ангилал",
        allProgram: "Бүх программ",
        unGrouped: "Ангилалгүй",
        replaceProgram: "Программ солих",
        replaceProgramTip: "Шинэ нийтлэсэн программ нь төгсгөлийн программийн өмнөх нийтлэсэн программийн өгөгдлийг солих болно!",
        screen: "Нэг/Хос дэлгэц",
        singleScreen: "Нэг дэлгэц",
        doubleScreen: "Хос дэлгэц",
        playSetting: "Тоглуулах тохируулга",
        batchPlaySetting: "Бүлэг тоглуулах хугацааг тохируулах",
        individualPlaySetting: "Тус бүр тоглуулах хугацааг тохируулах",
        playTime: "Тоглуулах хугацаа",
        daily: "Өдөр тутам",
        weekdays: "Даваа-Баасан",
        monthly: "Одоогийн сар",
        advancedSetting: "Нарийн тохируулга",
        playProgram: "Программ тоглуулах",
        searchProgram: "Түлхүүр үг оруулна уу",
        shareAddressNotExist: "Холбоос хаяг байхгүй байна, дахин оролдоно уу",
        copySuccess: "Хуулбарласан амжилттай",
        shareLink: "Хуваалцах холбоос",
        publish: "Нийтлэх",
        noResource: "Нөөц байхгүй",
        single: "Нэг дэлгэц",
        double: "Хос дэлгэц",
        time: "Цаг",
        associatedTerminalNum: "Холбоотой төгсгөлийн тоо",
        default: "Анхдагч",
        moveGroup: "Ангилал шилжүүлэх",
        pleaseSelectGroup: "Ангилалын нэрийг бөглөнө үү!",
        copy: "Хуулбарлах",
        FUBEN: "Хуулбар",
        nameempty: "Нэр хоосон байж болохгүй",
        whitespace: "Нэршлийн алдаа, файлын нэрэнд зай байж болохгүй!",
        programWhitespace: "Нэршлийн алдаа, программийн нэрэнд зай байж болохгүй!",
        pleaseSelectResolution: "Зураглал сонгоно уу!",
        dataError: "Өгөгдөл буруу байна!",
        createProgram: "Шинэ программ үүсгэх",
        directCreate: "Шууд үүсгэх",
        myTemplate: "Миний загварууд",
        use: "Ашиглах",
        free: "Үнэ төлбөргүй",
        loadMore: "Илүү ачаалах",
        confirmDelete: "Устгахад баталгаажуулах",
        deleteGroup: "Ангилал устгах",
        notPublished: "Нийтлээгүй",
        notPassed: "Зөвшөөрөөгүй",
        notUsed: "Ашиглаагүй",
        confirmDeleteSelectedProgram: "Сонгосон программийг устгахад баталгаажуулах уу?",
        companyName: "Компанийн нэр",
        programCannotDownload: "Энэ программ утгаж авах боломжгүй!",
        publishMaterial: "Суурь материал нийтлэх",
        playMaterial: "Суурь материал тоглуулах",
        pleaseInputMaterialName: "Суурь материалын нэр оруулна уу",
        size: "Хэмжээ",
        pleaseInputDeviceName: "Төхөөрөмжийн нэр оруулна уу",
        item: "бүртгэл",
        allMaterial: "Бүх суурь материал",
        allDevices: "Бүх төхөөрөмж",
        saveSuccess: "Хадгалсан амжилттай",
        savefaill: "Хадгалах амжилтгүй",
        playMode: "Тоглуулах арга",
        cyclePlay: "Дугаарлах",
        insertPlay: "Задлан тоглуулах",
        noData: "Өгөгдөл байхгүй",
        Add: "Нэмэх",
        "replace": "Солих",
        "repeat": "Дахих",
        "start01": "Эхлэх",
        "end01": "Дуусах",
        "startDate": "Эхлэх огноо",
        "endDate": "Дуусах огноо",
        "useNow": "Шууд ашиглах",
        "fillStartEndTimeFirst": "Эхлэх ба дуусах хугацааг бөглөсний дараа нэмнэ үү",
        "fillFullPlayTime": "Тоглуулах хугацааг бүрэн бөглөнө үү",
        "fillCorrectPlayTime": "Зөв тоглуулах хугацааны хугацааг бөглөнө үү",
        "sDateAndEDateBothEmptyOrFilled": "Эхлэх огноо ба дуусах огноо зэрэгцэн хоосон эсвэл хоосон биш байх ёстой"
    },
    source: {
        addResource: "Нөөц нэмэх",
        width: "Өргөн",
        height: "Өндөр",
        size: "Хэмжээ (КБ)",
        name: "Нэр",
        pleaseInputResourceName: "Нөөцийн нэр оруулна уу!",
        addToGroup: "Ангилалд нэмэх",
        remark: "Тэмдэглэл",
        promptFgIllustrate: "Зургийн тайлбар",
        promptFgRealisticPhoto: "Бодит зургийн стиль",
        promptFgSimplisticDrawing: "Хялбар зураг",
        promptFgChineseStyle: "Хятадын хэв маяг",
        promptFgPixelArt: "Пиксель урлаг",
        noModel: "Загвар байхгүй тул админтай холбогдоно уу!",
        getModelFailed: "Загвар авч чадалгүй байна, удаахад дахин оролдоно уу! Эсвэл админтай холбогдоно уу!",
        createImagePrompt: "Зураг үүсгэж байна, удаахад хаагаарай!",
        promptEmpty: "Тулгуур үг оруулна уу",
        dpiEmpty: "Зургийн харьцааг сонгоно уу!",
        fgEmpty: "Хэв маягийг сонгоно уу!",
        style: "Хэв маяг",
        idEmpty: "Зургийн ID хоосон байж болохгүй",
        exist: "Энэ зургийн суурь материалд аль хэдийн байна",
        addSuccess: "Суурь материал амжилттай нэмэгдлээ",
        saveError: "Зураг хадгалах амжилтгүй, дахин оролдоно уу!",
        delSuccess: "Устгасан амжилттай",
        generateImage: "Текстээс зураг",
        generateImagePlaceholder: 'Та үүсгэхийг хүссэн зургийн тайлбарыг оруулна уу, жишээлбэл: хавцгал дундуур үүлэнэ',
        aiExpand: "Оюуны тэлэлт",
        negativePrompt: "Сөрөг тулгуур үг",
        negativePromptTooltip: "Хэрэглэгч гаралтанд байхыг хүсэхгүй агуулга эсвэл шинж чанарыг тодорхой хасахад ашиглагддаг",
        imageRatio: "Зургийн харьцаа",
        generateImageBtn: "Шууд үүсгэх",
        shengchengjieguo: "Үүсгэсэн үр дүн",
        generateImageLoadingTip: "Үүсгэж байна, давтан дарвал эсвэл хаахгүй байхыг хүсч байна...",
        Tooltip: "Оюуны бүтээлийг AI-ээр бий болгох боломжтой",
        saveToMaterial: "Суурь материалд хадгалах",
        publish: "Шууд нийтлэх",
        download: "Утгаж авах",
        generateHistory: "Үүсгэсэн түүх",
        hide: "Нуух",
        cancel: "Цуцлах",
        useExpand: "Тэлэлтийг ашиглах",
        all: "Бүгд",
        delete: "Устгах",
        loadMore: "Илүү ачаалах",
        aiTip: "Агуулга нь оюуны загвараар үүсгэгдсэн бөгөөд платформийн байр суурь, сэтгэлгээг илэрхийлдэггүй. AI агуулгыг хууль ёсны ашиглаарай",
        operationSuccess: "Үйлдэл амжилттай",
        moveGroup: "Ангилал шилжүүлэх",
        groupName: "Ангилалын нэр",
        pleaseSelectGroup: "Ангилалын нэрийг сонгоно уу!",
        shenhe: "Шалгах",
        shenheStatus: "Шалгалтын төлөв",
        shenheSuccess: "Шалгалт зөвшөөрсөн",
        shenheRefuse: "Шалгалт татгалзсан",
        pleaseSelectShenheStatus: "Шалгалтын төлөвийг сонгоно уу!",
        shenheRemark: "Шалгалтын тэмдэглэл",
        pleaseInputShenheRemark: "Шалгалтын тэмдэглэл оруулна уу!",
        pleaseInputFileName: "Файлын нэрийг оруулна уу!",
        whitespace: "Нэршлийн алдаа, файлын нэрэнд зай байж болохгүй!",
        dataError: "Өгөгдөл буруу байна!",
        confirmDelete: "Устгахад баталгаажуулах",
        confirm: "Баталгаажуулах",
        deleteFolder: "Хавтанг устгах",
        add: "Нэмэх",
        edit: "Засварлах",
        fileName: "Файлын нэр",
        group: "Ангилал",
        resolution: "Зураглал",
        type: "Төрөл",
        image: "Зураг",
        music: "Хөгжим",
        video: "Видео",
        uploadTime: "Хуулбараалсан цаг",
        uploadUser: "Хуулбараалсан хүн",
        checkTime: "Шалгасан цаг",
        checkUser: "Шалгагч",
    },
    setting: {
        nameempty: "Нэр хоосон байж болохгүй",
        heightempty: "Өндөр хоосон байж болохгүй",
        widthempty: "Өргөн хоосон байж болохгүй",
        resolutionratio: "Зураглал",
        name: "Нэр",
        opteration: "Үйлдэл",
        compile: "Засварлах",
        delete: "Устгах",
        newz: "Нэмэх",
        compileratio: "Зураглал засварлах",
        sheizhifenbianlvmingcheng: "Зураглалын нэр тохируулах",
        shezhigaodu: "Өндөр тохируулах",
        shezhikuandu: "Өргөн тохируулах",
        xinzengfenbianlv: "Шинэ зураглал нэмэх",
        bianma: "Кодлолт",
        bianjizhongduanmingcheng: "Төгсгөлийн нэр засварлах",
        xinzengzhongduan: "Шинэ төгсгөл нэмэх",
        selectPrimaryColor: 'Үндсэн өнгийг сонгох',
        fullScreen: 'Дэлгэц дүүргэх',
        exitFullScreen: 'Дэлгэц дүүргэхээс гарах',
    },
    tabs: {
        refresh: 'Шинэчлэх',
        refreshAll: 'Бүгдийг шинэчлэх',
        close: 'Хаах',
        closeOthers: 'Бусдыг хаах',
        closeAll: 'Бүгдийг хаах',
        closeLeft: 'Зүүн талын хаах',
        closeRight: 'Баруун талын хаах',
    },
    errorPage: {
        needLogin: 'Та нэвтэрээгүй байна!',
        pageNotFound: 'Та хандах хуудас байхгүй байна!',
        redirectTo: 'Шилжих',
        orReturn: 'Эсвэл буцах',
        previousStep: 'Өмнөх алхам',
    },
    headerUs: {
        systemNotice: "Системийн мэдээ",
        allNotices: "Бүх мэдээ",
        viewAllMessages: "Бүх мессежийг харах",
        contactUs: "Бидэнтэй холбогдох",
        operationSuccess: "Үйлдэл амжилттай!",
        leaveMessage: "Мессеж бичих",
        messageTitle: "Гарчиг",
        messageTitleTip: "Гарчиг оруулна уу!",
        messageContentTip: "150 үгээс дээшгүй",
        submit: "Илгээх",
        markAsRead: "Уншсан гэж тэмдэглэх",
        success: "Үйлдэл амжилттай!"
    },
    material: {
        allMaterial: "Бүх суурь материал",
        defaultGroup: "Анхдагч ангилал",
        auditStatus: "Шалгалтын төлөв",
        auditPassed: "Шалгалт зөвшөөрсөн",
        auditRejected: "Шалгалт татгалзсан",
        pendingAudit: "Шалгалт хүлээгдэж байна",
        all: "Бүгд",
        operateSuccess: "Үйлдэл амжилттай!",
        pleaseSelectMaterial: "Суурь материал сонгоно уу!",
        moveGroup: "Ангилал шилжүүлэх",
        pleaseSelectGroup: "Ангилал сонгоно уу!",
        batchPublish: "Бүлэг нийтлэх",
        batchRecall: "Бүлэг татах",
        batchDelete: "Бүлэг устгах",
        materialList: "Суурь материалын жагсаалт",
        uploadMaterial: "Суурь материал хуулбараалах",
        materialType: "Суурь материалын төрөл",
        pleaseInputMaterialName: "Суурь материалын нэр оруулна уу",
        selectAll: "Бүгдийг сонгох",
        confirmDeleteSelectedMaterial: "Сонгосон суурь материалыг устгахад баталгаажуулах уу?",
        deleteSuccess: "Устгасан амжилттай",
        delete: "Устгах",
        publish: "Нийтлэх",
        recall: "Татах",
        confirmRecallSelectedMaterial: "Сонгосон суурь материалыг татаж авахад баталгаажуулах уу?",
        pleaseSelectMaterialGroup: "Суурь материалын ангиллыг сонгоно уу!",
        recallSuccess: "Татаж авсан амжилттай",
        publishSuccess: "Нийтлэсэн амжилттай",
        batchOperate: "Бүлэг үйлдэл",
        item: "бүртгэл",
        confirmDelete: "Устгахад баталгаажуулах уу?",
        edit: "Засварлах",
        confirmRecall: "Татахад баталгаажуулах уу?",
        unaudited: "Шалгаагүй",
        notPassed: "Зөвшөөрөөгүй",
        operate: "Үйлдэл",
        resolution: "Зураглал",
        none: "Байхгүй",
        confirm: 'Баталгаажуулах',
        cancel: 'Цуцлах',
        AICreation: "AI бүтээл",
    },
    uploadFile: {
        operationSuccess: "Үйлдэл амжилттай",
        uploadFile: "Хуулбараалалтын удирдлага",
        uploadSuccess: "Хуулбараалсан амжилттай",
        uploadCompleted: "Хуулбараалалт дууслаа",
        uploadFail: "Хуулбараалалт амжилтгүй",
        ConversionFailed: "Хувиргалт амжилтгүй!",
        loading: "Ачааллаж байна...",
        beQueuing: "Дараалалд байна...",
        Uploading: "Хуулбараалж байна...",
        ConversionIng: "Хувиргаж байна...",
        ConventionalResources: "Ерөнхий нөөц",
        DocumentResources: "Баримт бичгийн нөөц",
        complete: "Дуусгасан",
        upload: "Хуулбараалах",
        fileSizeWraning01: "Суурь материалын хэмжээ хэтэрсэн",
        fileSizeWraning02: "Засварлаад дахин хуулбараална уу!",
        fileIsEmpty: "Файл хоосон",
        uploadFileTip: "Дэмжигддэггүй файлын формат",
        unablePreview: "Суурь материалын сан руу амжилттай нэмэгдээгүй, урьдчилан харах боломжгүй",
        confirmDelete: "Устгахад баталгаажуулах уу?",
        deleteSuccess: "Устгасан амжилттай",
        delete: "Устгах",
        confirm: "Баталгаажуулах",
        preview: "Урьдчилан харах",
        close: "Хаах",
        cancel: "Цуцлах",
        fileType: "Файлын төрөл",
        fileSize: "Файлын хэмжээ",
        conversionProgress: "Хувиргалтын явц",
        progress: "Явц",
        image: "Зураг",
        video: "Видео",
        audio: "Хөгжим",
        limitTip01: "Нэг удаад",
        limitTip02: "файл хуулбараална уу",
        okTip: "Суурь материал хуулбараалж байна, удаахад хаагаарай!",
        usableSize: 'Хүртэмжтэй зай',
        sizeUnableTip: "Одоогийн хүртэмжтэй хадгалах зай хүрэлцэхгүй байна, хэрэглэгдээгүй суурь материалыг цэвэрлэж зай хуримтлуулна уу эсвэл борлуулалтын хүмүүстэй холбогдож багтаамжийг нэмэгдүүлнэ үү.",
        view: "Нарийвчлал харах",
        fileName: "Файлын нэр",
    },
    template: {
        inputPlaceholder: 'Оруулна уу',
        selectPlaceholder: 'Сонгоно уу',
        noAuths: "Түр эрхгүй, админтай холбогдоно уу",
        operationSuccess: "Үйлдэл амжилттай",
        total: "Нийт",
        totalNum: "бүртгэл",
        dan: "Нэг",
        shaung: "Хос",
        pleaseSelectGroup: "Ангилал сонгоно уу",
        preview: "Урьдчилан харах",
        free: "Үнэ төлбөргүй",
        use: "Ашиглах",
        dpi: 'Зураглал',
        delete: "Устгах",
        confirmDelete: "Устгахад баталгаажуулах",
        confirmDeleteSelectedTemplate: "Энэ загварыг устгахад баталгаажуулах уу",
        push: "Нийтлэх",
        pushConfirm: "Нийтлэг загварт нийтлэхэд баталгаажуулах уу",
        pushRemovalConfirm: "Нийтлэг загвараас хасахад баталгаажуулах уу",
        templateOrderRecord: "Загвар захиалгын түүх",
        unpublished: "Нийтлээгүй",
        auditing: "Шалгалт хийж байна",
        publishRejected: "Нийтлэхэд татгалзсан",
        publishSuccess: "Нийтлэсэн амжилттай",
        offShelf: "Хаяхаас халах",
        公共模版: "Нийтлэг загвар",
        我的模板: "Миний загварууд",
        共享记录: "Хуваалцах түүх",
        name: "Нэр",
        pubdate: "Нийтлэсэн огноо",
        keySeachTip: "Түлхүүр үг оруулна уу",
        allGroup: "Бүх ангилал",
        add: "Нэмэх",
        edit: "Засварлах",
        programName: "Программ нэр",
        selectGroup: "Ангилал сонгох",
    },
    checkManage: {
        total: "Нийт",
        totalNum: "бүртгэл",
        operationSuccess: "Үйлдэл амжилттай",
        checkUserLogs: "Шалгалтын түүх (Ажилтан)",
        checkLogs: "Шалгалтын түүх (Шалгагч)",
        sourceCheck: "Суурь материал шалгах",
        programCheck: "Програм шалгах",
        checkAll: "Бүгдийг сонгох",
        auditPass: "Шалгалт зөвшөөрсөн",
        auditRefuse: "Шалгалт татгалзсан",
        auditPass01: "Зөвшөөрсөн",
        auditRefuse01: "Татгалзсан",
        auditRefuse02: "Шалгалт татгалзсан",
        auditor: "Шалгагч",
        agentUserName: "Нийтэлсэн хүн",
        interrogationTime: "Илтгэсэн цаг",
        checkTime: "Шалгасан цаг",
        checkName: "Шалгалтын нэр",
        checkType: "Шалгалтын төрөл",
        checkIp: "Илтгэсэн IP хаяг",
        checkReason: "Мессеж",
        checkStatus: "Үйлдлийн агуулга",
        rangePicker: "Шалгалтын огноо",
        keyWord: "Түлхүүр үг",
        all: "Бүгд",
        program: 'Программ',
        material: 'Суурь материал',
        dan: "Нэг",
        shaung: "Хос",
        pleaseSelectProgram: "Программ сонгоно уу!",
        pleaseSelectMaterial: "Суурь материал сонгоно уу!",
        preview: "Урьдчилан харах",
        dpi: 'Зураглал',
        auditRefuseTip: "Татгалзсан шалтгааныг оруулна уу",
        unreviewed: "Шалгаагүй",
        notPassed: "Зөвшөөрөөгүй",
        notUsed: "Ашиглаагүй",
        edit: "Засварлах",
        none: "Байхгүй",
        name: "Нэр",
        size: "Хэмжээ",
        type: "Төрөл",
        uploadTime: "Хуулбараалсан цаг",
        uploadUser: "Хуулбараалсан хүн",
        checkUser: "Шалгагч",
        image: "Зураг",
        music: "Хөгжим",
        video: "Видео",
    },
    systemSet: {
        total: "Нийт",
        totalNum: "бүртгэл",
        inputPlaceholder: 'Оруулна уу',
        selectPlaceholder: 'Сонгоно уу',
        userList: "Байгууллагын гишүүд",
        roleList: "Үүрэг эрх",
        department: "Байгууллагын бүтэц",
        diskInfo: "Хадгалах зай",
        approveSet: "Агуулга шалгах",
        logList: "Лоог удирдлага",
        name: "Нэр",
        account: "Бүртгэл",
        userName: "Хэрэглэгчийн нэр",
        phoneNumber: "Утасны дугаар",
        role: "Үүрэг",
        createTime: "Үүсгэсэн цаг",
        operation: "Үйлдэл",
        edit: "Засварлах",
        delete: "Устгах",
        addNew: "Шинээр нэмэх",
        add: "Нэмэх",
        resetPassword: "Нууц үг сэргээх",
        confirmDelete: "Устгахад баталгаажуулах",
        departmentOrganization: "Байгууллага",
        addNewUser: "Шинэ хэрэглэгч нэмэх",
        pleaseEnterUserName: "Хэрэглэгчийн нэр оруулна уу",
        confirmPasswordNotMatch: "Баталгаажуулах нууц үг нь нууц үгтэй зөрчилтэй байна!",
        operationSuccess: "Үйлдэл амжилттай!",
        userNickname: "Хэрэглэгчийн нэр",
        pleaseEnterUserNickname: "Хэрэглэгчийн нэр оруулна уу",
        userNicknameRequired: "Хэрэглэгчийн нэр хоосон байж болохгүй!",
        password: "Нууц үг",
        pleaseEnterPassword: "Нууц үг оруулна уу",
        passwordRequired: "Нууц үг хоосон байж болохгүй!",
        passwordTip: "Таны нууц үгийн аюулгүй байдал хэт бага (нууц үгэнд том, жижиг үсэг, тоо, онцгой тэмдэгтнүүдийн 3-ыг агуулсан 8-аас доошгүй тэмдэгт байх ёстой)",
        confirmPassword: "Баталгаажуулах нууц үг",
        pleaseEnterPhoneNumber: "Утасны дугаар оруулна уу",
        phoneNumberRequired: "Утасны дугаар хоосон байж болохгүй!",
        phoneNumberFormatError: "Зөв утасны дугаар оруулна уу!",
        roleRequired: "Үүрэг хоосон байж болохгүй!",
        required: "Хоосон байж болохгүй!",
        departmentName: "Байгууллага",
        modifyPassword: "Нууц үг өөрчлөх",
        newPassword: "Шинэ нууц үг",
        pleaseEnterNewPassword: "Шинэ нууц үг оруулна уу",
        pwdMessage: "Нууц үг 8~20 тэмдэгт урттай, зай агуулаагүй, том, жижиг үсэг, тоо, онцгой тэмдэгтнүүдээс 3 төрлийг агуулсан байх ёстой",
        all: "Бүгд",
        noAuths: "Түр эрхгүй, админтай холбогдоно уу",
        departmentName01: "Байгууллагын нэр",
        image: "Зураг",
        music: "Хөгжим",
        video: "Видео",
        buySize: "Худалдан авсан тоо",
        totalMoney: "Төлсөн нийт мөнгө",
        buycreateTime: "Худалдан авсан цаг",
        endTime: "Дуусах цаг",
        buyTypeStr: "Захиалгын төрөл",
        sourceCheck: "Суурь материал шалгах",
        programCheck: "Програм шалгах",
        programName: "Программ нэр",
        diskExpansion: "Системийн ашиглах боломжтой зайг хадгалахын тулд дууссан/хэрэглээгүй суурь материалыг цаг тухайд нь цэвэрлэхийг зөвлөж байна. Хэрэв танд илүү их зай шаардлагатай бол төхөөрөмжийн нийлүүлэгчтэй холбогдож оюуны хадгалалтын зайг нэмэгдүүлэх үйлчилгээг аваарай. Энэ үйлчилгээ хураамж үүсгэх боломжтой бөгөөд нарийвчлалыг борлуулагчийн мэдээлэлд үндэслэнэ.",
        selectPermission: "Эрх сонгоно уу",
        checkPermission: "Эрхийг тэмдэглэнэ үү",
        addRole: "Үүрэг нэмэх",
        enterRoleName: "Үүргийн нэрийг оруулна уу",
        roleName: "Үүргийн нэр",
        roleNameRequired: "Үүргийн нэр хоосон байж болохгүй!",
        remark: "Тэмдэглэл",
        enterRemark: "Тэмдэглэл оруулна уу",
        permissionSetting: "Эрхийн тохируулга",
        deleteSuccess: "Устгасан амжилттай!",
        confirmToDelete: "Устгах уу?",
        orgName: "Байгууллагын нэр",
        orgNameRequired: "Байгууллагын нэр хоосон байж болохгүй!",
        orgRemark: "Байгууллагын тэмдэглэл",
        enterOrgRemark: "Байгууллагын тэмдэглэл оруулна уу",
        capacityUsage: "Багтаамжийн хэрэглээ",
        usedCapacity: "Ашигласан багтаамж",
        totalCapacity: "Нийт багтаамж",
        remainingCapacity: "Үлдсэн багтаамж",
        capacityExpansion: "Багтаамж нэмэгдүүлэх",
        enable: "Идэвхжүүлэх",
        disable: "Идэвхгүй болгох",
        userName01: "Хэрэглэгчийн нэр",
        loginTime: "Нэвтрэх цаг",
        ipAddress: "IP хаяг",
        loginResult: "Нэвтрэх үр дүн",
        selectDate: "Огноо сонгох",
        enterDate: "Огноо сонгоно уу",
        selectStartTime: "Эхлэх хугацааг сонгоно уу",
        selectEndTime: "Дуусах хугацааг сонгоно уу",
        enterUserName: "Хэрэглэгчийн нэр оруулна уу",
        userCount: "Хэрэглэгчийн тоо",
        roleDesc: "Үүргийн тайлбар",
        roleAuthorization: "Үүргийн зөвшөөрөл",
        success: "Амжилттай",
        failure: "Амжилтгүй",
        time: "Цаг",
        operationContent: "Үйлдлийн агуулга",
        playCount: "Тоглуулах тоо",
        playDuration: "Тоглуулах хугацаа",
        selectDevice: "Төхөөрөмж сонгох",
        enterProgramName: "Программ нэр оруулна уу",
        serialNumber: "Дугаар",
        publishContentName: "Нийтлэсэн агуулгын нэр",
        playMode: "Тоглуулах арга",
        cyclePlay: "Дугаарлах",
        insertPlay: "Задлан тоглуулах",
        paddingPlay: "Шахах тоглуулга",
        playDeviceId: "Тоглуулах төхөөрөмжийн ID",
        playDeviceName: "Тоглуулах төхөөрөмжийн нэр",
        publishTime: "Нийтлэсэн цаг",
        downloadStatus: "Утгаж авах төлөв",
        notDownloaded: "Утгаж аваагүй",
        downloading: "Утгаж аваж байна",
        downloadSucceeded: "Утгаж авсан амжилттай",
        downloadFailed: "Утгаж авах амжилтгүй",
        enterPublishContentName: "Нийтлэсэн агуулгын нэрийг оруулна уу",
        terminalId: "Төгсгөлийн ID",
        belongOrg: "Харьяалагдах байгууллага",
        reportTime: "Илгээсэн цаг",
        reportIp: "Илгээсэн IP",
        logInfo: "Лоогийн мэдээлэл",
        details: "Дэлгэрэнгүй",
        confirmDeletion: "Устгах уу?",
        logDetails: "Лоогийн дэлгэрэнгүй",
        download: "Утгаж авах",
        deptOrg: "Байгууллага",
        query: "Хайх",
        queryByTerminalId: "Төгсгөлийн ID-ээр хайх",
        batchDeleteLogs: "Бүлэг лоог устгах",
        customTimeDeleteLogs: "Хугацаагаар лоог устгах",
        selectTimeRangeFirst: "Эхлээд хугацааны мужийг сонгоно уу",
        deleteAllDeviceLogsIfEmpty: "Хэрэв төхөөрөмжийн ID-г хоосон орхивол бүх төхөөрөмжийн лоогийг устгана",
        enterDeviceIdToDeleteLogs: "Устгах лоогтэй төхөөрөмжийн ID-г оруулна уу",
        confirmDeleteAction: "Устгахад баталгаажуулах",
        selectDeleteRangeFirst: "Эхлээд устгах мужийг сонгоно уу",
        networkConnectionFailed: "Сүлжээний холболт амжилтгүй боллоо",
        playLog: "Тоглуулах лоог",
        publishLog: "Нийтлэлийн лоог",
        errorLog: "Алдааны лоог",
        operationLog: "Үйлдлийн лоог",
        fileLog: "Файлын лоог",
        userOperateLog: "Нэвтрэх лоог",
    },
    userManual: {
        userManual: "Хэрэглэгчийн гарын авлага",
        noData: "Өгөгдөл байхгүй",
    },
    systemNotice: {
        systemNotice: "Системийн мэдээ",
        noData: "Өгөгдөл байхгүй",
        total: "Нийт",
        totalNum: "бүртгэл",
        "markAllRead": "Бүгдийг уншсан",
        "deleteAll": "Бүгдийг устгах",
        "all": "Бүгд",
        "unread": "Уншаагүй",
        "read": "Уншсан",
        "type": "Төрөл",
        "content": "Агуулга",
        "date": "Огноо",
        "status": "Төлөв",
        "confirmDelete": "Устгах уу?",
        "confirm": "Баталгаажуулах",
        "cancel": "Цуцлах",
        "delete": "Устгах"
    }
};